import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'
import { FancyProgress } from '../ui/progress'
import { type TransactionStatusProgressProps, StepState } from '../../types/transactions'

export function TransactionStatusProgress({
  status,
  steps,
  getStepState,
  getProgressValue,
}: TransactionStatusProgressProps) {
  const getStatusIcon = (stepLabel: string, index: number) => {
    const stepState = getStepState(index)

    let urlLabel = ''
    switch (stepState) {
      case StepState.Completed:
        urlLabel = 'check'
        break
      case StepState.Failed:
        urlLabel = 'error'
        break
      case StepState.Pending:
      case StepState.Loading:
        urlLabel = 'load'
        break
    }

    if (!urlLabel) return null

    switch (stepLabel) {
      case 'Created':
      case 'Completed':
        return <img src={`/status/circle-${urlLabel}.svg`} alt={`Status icon for ${stepLabel}`} />
      case 'Initiated':
      case 'Transfer Main':
        return <img src={`/status/diamond-${urlLabel}.svg`} alt={`Status icon for ${stepLabel}`} />

      case 'Executed Swap':
      case 'Transfer Client':
        return <img src={`/status/square-${urlLabel}.svg`} alt={`Status icon for ${stepLabel}`} />
    }
  }

  const isDestructive = !!steps.find((_stepLabel, index) => {
    const stepState = getStepState(index)
    return stepState === StepState.Failed
  })

  return (
    <Card className="border-none bg-transparent">
      <CardHeader className="p-0">
        <CardTitle className="text-2xl font-bold">Transaction Status</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="space-y-8">
          <FancyProgress
            value={getProgressValue(status)}
            isDestructive={isDestructive}
            className="w-full"
          />

          <div className="space-y-3 grid grid-cols-6 w-full">
            {steps.map((stepLabel, index) => {
              return (
                <div
                  key={stepLabel}
                  className="flex shrink-0 flex-col items-center col-span-1 px-2"
                >
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center`}>
                    {getStatusIcon(stepLabel, index)}
                  </div>
                  <span className={`text-xs font-bold text-center mt-2`}>{stepLabel}</span>
                </div>
              )
            })}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
